import React, { useState } from "react";
import { useNavigate } from "react-router-dom";
import { FaBars, FaMapMarkerAlt, FaShieldAlt } from "react-icons/fa";
import "../CSS/App.css";
import SideModal from "./SideModal";
import ProfileMenu from "./ProfileMenu";
import NotificationBell from "./NotificationBell";
import EventsCard from "./EventsCard";

// Safety Check-In is parked for now - hidden from the dashboard. The screens
// and route stay in the code so it's a one-line flip to bring back.
const SAFETY_ENABLED = false;

// SmartThings-style landing: the app's main features as big, tappable tiles.
// Tapping a tile opens the real screen. Secondary/less-used actions live in
// the side menu (hamburger); account actions live in the profile menu.
const FEATURES = [
  {
    label: "My Addresses",
    description: "View & share your saved places",
    icon: FaMapMarkerAlt,
    color: "#007bff",
    route: "/addresses",
  },
  {
    label: "Safety Check-In",
    description: "Check in & alert your contacts",
    icon: FaShieldAlt,
    color: "#28a745",
    route: "/safety",
    enabled: SAFETY_ENABLED,
  },
];

const Home = () => {
  const navigate = useNavigate();
  const [menuOpen, setMenuOpen] = useState(false);

  return (
    <div
      className="App container"
      style={{
        width: "100%",
        maxWidth: "100%",
        margin: 0,
        borderRadius: 0,
        boxSizing: "border-box",
        // Bounded to the viewport so the page itself doesn't scroll - only the
        // events list inside the card does (see the EventsCard wrapper below).
        height: "100dvh",
        overflow: "hidden",
        paddingTop: "calc(30px + env(safe-area-inset-top, 0px))",
        paddingLeft: "calc(20px + env(safe-area-inset-left, 0px))",
        paddingRight: "calc(20px + env(safe-area-inset-right, 0px))",
        paddingBottom: "calc(20px + env(safe-area-inset-bottom, 0px))",
        display: "flex",
        flexDirection: "column",
      }}
    >
      {/* Header: menu, title, profile. position:relative anchors the profile
          popup (see ProfileMenu). */}
      <div
        style={{
          position: "relative",
          display: "flex",
          alignItems: "center",
          gap: "10px",
          marginBottom: "24px",
        }}
      >
        <button
          className="menu-button"
          onClick={() => setMenuOpen(true)}
          style={{
            display: "inline-flex",
            alignItems: "center",
            justifyContent: "center",
          }}
          aria-label="Menu"
        >
          <FaBars style={{ display: "block" }} />
        </button>
        <SideModal isOpen={menuOpen} onClose={() => setMenuOpen(false)} />

        <h1 style={{ flex: 1, margin: 0, fontSize: "26px" }}>iBlink</h1>

        <NotificationBell />
        <ProfileMenu />
      </div>

      <p
        style={{
          margin: "0 0 18px",
          color: "var(--text-secondary, #777)",
          fontSize: "15px",
        }}
      >
        What would you like to do?
      </p>

      {/* Feature tiles */}
      <div
        style={{
          display: "grid",
          gridTemplateColumns: "repeat(2, 1fr)",
          gap: "14px",
        }}
      >
        {FEATURES.filter((f) => f.enabled !== false).map(
          ({ label, description, icon: Icon, color, route }) => (
          <button
            key={route}
            onClick={() => navigate(route)}
            style={{
              display: "flex",
              flexDirection: "column",
              alignItems: "flex-start",
              gap: "10px",
              textAlign: "left",
              padding: "18px 16px",
              minHeight: "140px",
              borderRadius: "16px",
              border: "1px solid var(--border-color, #ddd)",
              backgroundColor: "var(--item-bg, #fff)",
              color: "var(--text-primary, #1a1a1a)",
              cursor: "pointer",
              boxShadow: "0 1px 4px rgba(0,0,0,0.06)",
            }}
          >
            <div
              style={{
                width: "46px",
                height: "46px",
                borderRadius: "12px",
                backgroundColor: `${color}22`,
                color: color,
                display: "flex",
                alignItems: "center",
                justifyContent: "center",
                flexShrink: 0,
              }}
            >
              <Icon size={22} />
            </div>
            <div style={{ fontSize: "16px", fontWeight: 700 }}>{label}</div>
            <div
              style={{
                fontSize: "12.5px",
                color: "var(--text-secondary, #777)",
                lineHeight: 1.3,
              }}
            >
              {description}
            </div>
          </button>
        ))}
      </div>

      {/* Events hub: start/join + the events you're currently in. Fills the
          space left below the tiles so its list scrolls inside the card. */}
      <div
        style={{
          marginTop: "14px",
          flex: 1,
          minHeight: 0,
          display: "flex",
          flexDirection: "column",
        }}
      >
        <EventsCard />
      </div>
    </div>
  );
};

export default Home;
